import React, { useMemo } from 'react';

import { usePageContent } from '~/App/shared/hooks/use-page-content';

import { CmsProductThankYou } from './CmsProductThankYou';
import { loadData } from './CmsProductThankYou.LoadData';

const View = (props: unknown) => {
  const pageContent = usePageContent();
  const children = useMemo(
    () =>
      pageContent ? <CmsProductThankYou {...pageContent} {...props} /> : null,
    [pageContent, props]
  );

  return children;
};

View.loadData = loadData;

export default View;
